module.exports = __webpack_public_path__ + "static/media/loader-custom.4e74aef9.svg";